import { render, staticRenderFns } from "./Leadership.vue?vue&type=template&id=f5596bbe&scoped=true&"
import script from "./Leadership.vue?vue&type=script&lang=js&"
export * from "./Leadership.vue?vue&type=script&lang=js&"
import style0 from "./Leadership.vue?vue&type=style&index=0&id=f5596bbe&prod&lang=css&"
import style1 from "./Leadership.vue?vue&type=style&index=1&id=f5596bbe&prod&scoped=true&lang=css&"
import style2 from "./Leadership.vue?vue&type=style&index=2&id=f5596bbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5596bbe",
  null
  
)

export default component.exports